'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/comps/primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/comps/primitives/tooltip';
import { UserDimensionMappingDialog } from '@/domains/pages/shared/user-dimension-mapping-dialog';
import { getSegmentEmptyCopy } from '@/domains/pages/ai-proficiency/utils/segment-empty-state';
import type { SegmentKind } from '@/domains/pages/shared/segment-kind';
import { useAuthContext } from '@/hooks/use-auth';
import { useProjectsContext } from '@/providers/projects-provider';
import { cn } from '@/utils/shad';
import { Info, Tags } from 'lucide-react';
import { useState } from 'react';
type SegmentDimensionMappingTriggerProps = {
  segmentKind: SegmentKind;
  className?: string;
};
export function SegmentDimensionMappingTrigger(t0) {
  const $ = _c(21);
  const {
    segmentKind,
    className
  } = t0;
  const {
    isCompanyAdmin,
    isNebulyAdmin
  } = useAuthContext();
  const isAdmin = isCompanyAdmin || isNebulyAdmin;
  const {
    projectId
  } = useProjectsContext();
  const [mappingOpen, setMappingOpen] = useState(false);
  let t1;
  if ($[0] !== segmentKind) {
    t1 = getSegmentEmptyCopy(segmentKind);
    $[0] = segmentKind;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copy = t1;
  if (!isAdmin) {
    return null;
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("h-7 shrink-0 gap-1.5 rounded-full px-3 text-xs text-muted-foreground hover:text-foreground", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setMappingOpen(true);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `segment-dimension-mapping-trigger-${segmentKind}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Tags className="size-3.5" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TooltipTrigger asChild={true}><span className="inline-flex text-muted-foreground hover:text-foreground" onClick={_temp} onPointerDown={_temp2} aria-label="About legacy tag mapping"><Info className="size-3.5" /></span></TooltipTrigger>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== copy.mappingCtaTooltip) {
    t7 = <Tooltip>{t6}<TooltipContent side="top" className="max-w-xs text-start text-wrap">{copy.mappingCtaTooltip}</TooltipContent></Tooltip>;
    $[7] = copy.mappingCtaTooltip;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== copy.mappingCtaLabel || $[10] !== t2 || $[11] !== t4 || $[12] !== t7) {
    t8 = <Button variant="outline" size="sm" className={t2} onClick={t3} data-testid={t4}>{t5}{copy.mappingCtaLabel}{t7}</Button>;
    $[9] = copy.mappingCtaLabel;
    $[10] = t2;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== mappingOpen || $[15] !== projectId || $[16] !== segmentKind) {
    t9 = <UserDimensionMappingDialog open={mappingOpen} onOpenChange={setMappingOpen} segmentKind={segmentKind} projectId={projectId} />;
    $[14] = mappingOpen;
    $[15] = projectId;
    $[16] = segmentKind;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}